import styled from "styled-components";
import { mq } from "./util/media";

const ButtonStyle = styled.a`

  transition: 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }


  letter-spacing: 0.5px;
  background: transparent;
  color: #F9D85E;
  font-size: 1rem;
  border: none;
  display: flex;
  align-items: center;
  font-weight: bold;
  text-decoration: none;

  ${mq.lt.md} {
    font-size: 15px;

  }

  ${mq.lt.sm} {
    font-size: 9px;
    padding: 1rem 0.8rem;
    line-height: 0;
    height: 0;
  }
`

const Info = styled.span`
  color: #F9D85E;
  border-radius: 50%;
  font-weight: 700;
  font-size: 0.4em;
  display: inline-block;
  margin-left: 0.5rem;
  display: flex;

  & svg {
    width: 14px;
    height: 14px;
  }

  ${mq.lt.sm} {
    margin-left: 0.25rem;
  }
`

function LearnMore() {

  return(
    <ButtonStyle href="https://near-treasury.gitbook.io/near-treasury-tm/" target="_blank" rel="noreferrer">
      Learn More <Info><svg viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 9.625C7.77817 9.625 9.625 7.77817 9.625 5.5C9.625 3.22183 7.77817 1.375 5.5 1.375C3.22183 1.375 1.375 3.22183 1.375 5.5C1.375 7.77817 3.22183 9.625 5.5 9.625Z" stroke="#F9D85E" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.5 5.04169V7.33335" stroke="#F9D85E" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.47717 3.66669H5.52301V3.71252H5.47717V3.66669Z" stroke="#F9D85E" stroke-linecap="round" stroke-linejoin="round"/></svg></Info>
    </ButtonStyle>
  )
}

export default LearnMore;